import { Home } from 'react-feather'

export default [
	// { header: '' },
	{
		id: 'account',
		title: 'Tài khoản',
		icon: <Home size={20} />,
		navLink: '/account'
	}
]
